module.exports = __webpack_public_path__ + "static/media/logo.49767672.png";